import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi } from "@zeytal/types";

import { paintToSelectedFormat } from "../../../utils/colors.ts";

export const createDropShadow = (
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  effect: FigmaRestApi.DropShadowEffect,
) => {
  const {
    offset: { x, y },
    radius,
    color,
  } = effect;
  const effectColor = paintToSelectedFormat(stylesFormatsConfig.colors, color);

  return `${x}px ${y}px ${radius}px ${effectColor}`;
};
